/**
Author - Shreshtha Sharma
Git - https://github.com/shreshtha-wealthy
**/

const countryCodeChoices = [
  {
    iconUrl: "/static/next/assets/countryFlags/india.svg",
    country: "India (+91)",
    code: "(+91)"
  },
  {
    iconUrl: "/static/next/assets/countryFlags/uae.svg",
    country: "UAE (+971)",
    code: "(+971)"
  },
  {
    iconUrl: "/static/next/assets/countryFlags/saudiarabia.svg",
    country: "Saudi Arabia (+966)",
    code: "(+966)"
  },
  {
    iconUrl: "/static/next/assets/countryFlags/newzealand.svg",
    country: "New Zealand (+64)",
    code: "(+64)"
  },
  {
    iconUrl: "/static/next/assets/countryFlags/singapore.svg",
    country: "Singapore (+65)",
    code: "(+65)"
  },
  {
    iconUrl: "/static/next/assets/countryFlags/malaysia.svg",
    country: "Malaysia (+60)",
    code: "(+60)"
  },
];

export default countryCodeChoices;
